export default "__VITE_ASSET__15bcf201__"